<div class="buscador-direccion">
  <mat-google-maps-autocomplete (keydown.enter)="loadCoordenada($event);" [addressLabelText]="'Ingrese una dirección o coordenada'"
  [invalidErrorText]="''" [placeholderText]="'Ingrese una dirección o coordenadas'"
  [appearance]="appearance.OUTLINE" (onAutocompleteSelected)="onLocationSelected($event)">
</mat-google-maps-autocomplete>
</div>
